import { Warning } from '@phosphor-icons/react';
import {
  Subscription,
  SubscriptionStatus,
} from '../../../../types/Subscription';

type PaymentIssueBannerProps = {
  subscription: Subscription | null;
};

const formatAmount = (amountCents?: number, currency?: string) => {
  if (!amountCents || amountCents <= 0) {
    return null;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'usd',
  }).format(amountCents / 100);
};

const PaymentIssueBanner: React.FC<PaymentIssueBannerProps> = ({
  subscription,
}) => {
  if (
    subscription?.status !== SubscriptionStatus.PAST_DUE &&
    subscription?.status !== SubscriptionStatus.UNPAID
  ) {
    return null;
  }

  const paymentIssue = subscription.paymentIssue;

  const amount = formatAmount(
    paymentIssue?.amountRemaining || paymentIssue?.amountDue,
    paymentIssue?.currency
  );

  const isPastDue = subscription.status === SubscriptionStatus.PAST_DUE;
  const ctaHref = paymentIssue?.hostedInvoiceUrl || '/account?sub=billing';

  return (
    <div className="payment-issue-banner" role="alert">
      <Warning className="payment-issue-banner_icon" weight="fill" />
      <div className="payment-issue-banner_content">
        <div className="payment-issue-banner_title">
          {isPastDue ? 'Payment Issue' : 'Payment required to restore access'}
        </div>
        <div className="payment-issue-banner_body">
          {isPastDue
            ? `We could not process your latest Ora payment${amount ? ` of ${amount}` : ''}. Please pay the open invoice or update your card before your subscription is cancelled.`
            : `Your Ora subscription needs payment${amount ? ` of ${amount}` : ''} before paid access can resume.`}
        </div>
      </div>
      <div className="payment-issue-banner_actions">
        <a
          className="button"
          href={ctaHref}
          rel={
            paymentIssue?.hostedInvoiceUrl ? 'noopener noreferrer' : undefined
          }
          target={paymentIssue?.hostedInvoiceUrl ? '_blank' : undefined}
        >
          Pay invoice
        </a>
        {paymentIssue?.hostedInvoiceUrl && (
          <a className="button button--secondary" href="/account?sub=billing">
            Billing
          </a>
        )}
      </div>
    </div>
  );
};

export default PaymentIssueBanner;
